/**
 * Implementation of common CSS Timing functions
 */
export const TIMING_FUNCTION = {
    linear: (x: number) => x,
    easeIn: (x: number) => Math.pow(x, 1.675),
    easeOut: (x: number) => 1 - Math.pow(1 - x, 1.675),
    easeInOut: (x: number) => 0.5 * (Math.sin((x - 0.5) * Math.PI) + 1),
};

export type TimingFunction = keyof typeof TIMING_FUNCTION;
